import { useTranslation } from 'react-i18next';
import { PageContentCard } from '@/components/layout/PageContentCard';
import type { Step } from '../types';

interface DeviceAssignmentDesktopProps {
  steps: Step[];
  isStepDisabled: (stepId: Step['id']) => boolean;
  renderStepContent: (stepId: Step['id']) => React.ReactNode;
}

export function DeviceAssignmentDesktop({
  steps,
  isStepDisabled,
  renderStepContent,
}: DeviceAssignmentDesktopProps) {
  const { t } = useTranslation();

  return (
    <div className="hidden lg:grid lg:grid-cols-3 gap-3 flex-1 min-h-0">
      {steps.map((step) => {
        const disabled = isStepDisabled(step.id);

        return (
          <PageContentCard
            key={step.id}
            className={`flex-1 min-h-0 flex flex-col text-onsurface w-full bg-red ${disabled ? 'opacity-50' : ''}`}
          >
            <DeviceAssignmentHeader step={step} />
            {disabled ? (
              <div className="flex flex-col items-center justify-center py-12 text-center">
                <svg
                  className="size-12 opacity-60 mb-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                <p className="opacity-60">
                  {t('deviceAssignment.step3.selectCompanyFirst')}
                </p>
              </div>
            ) : (
              renderStepContent(step.id)
            )}
          </PageContentCard>
        );
      })}
    </div>
  );
}

function DeviceAssignmentHeader({ step }: { step: Step }) {
  const { t } = useTranslation();
  
  return (
    <div className="mb-4">
      <h3 className="text-lg font-semibold text-onsurface">{t(step.titleKey)}</h3>
      <p className="text-sm opacity-60 mt-1 h-[16px]">{step.getSubtitle() || ''}</p>
    </div>
  );
}
